import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "../notification.hook";
import {
  CERTIFICATE_ADDED_SUCCESS_LABEL,
  DATA_DELETED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../constants/Dictionary";
import CmSheetCertificateOfCoursesService from "../../services/api/cmSheet/CmSheetCertificateOfCourse.service";
import { CM_SHEET_COURSES_QUERY_KEY } from "./courses.hook";
import { UpdateCmSheetCertificateOfCoursesRequest } from "../../types/api/collaborators.type";

export const useUpdateCmSheetCourseCertificate = (
  cmSheetId: number,
  courseId: number,
) => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutateAsync: updateCourseCertificate, isPending: isUpdating } =
    useMutation({
      mutationFn: (body: UpdateCmSheetCertificateOfCoursesRequest) =>
        CmSheetCertificateOfCoursesService.update(cmSheetId, courseId, body),
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: [CM_SHEET_COURSES_QUERY_KEY],
        });
        notification.success(
          CERTIFICATE_ADDED_SUCCESS_LABEL,
          undefined,
          "toast",
        );
      },
      onError: (error) => {
        console.error(error);
        notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
      },
    });

  return { updateCourseCertificate, isUpdating };
};

export const useDeleteCmSheetCourseCertificate = (cmSheetId: number) => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutateAsync: deleteCourseCertificate, isPending: isDeleting } =
    useMutation({
      mutationFn: (courseId: number) =>
        CmSheetCertificateOfCoursesService.delete(cmSheetId, courseId),
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: [CM_SHEET_COURSES_QUERY_KEY],
        });
        notification.success(DATA_DELETED_SUCCESS_LABEL, undefined, "toast");
      },
      onError: (error) => {
        console.error(error);
        notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
      },
    });

  return { deleteCourseCertificate, isDeleting };
};
